import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Icon } from 'rsuite';
import styles from './DownloadButton.module.less';
import {
  getIsVideoUploadingToBucket,
} from '../../redux/modules/campaignLandingPage';

const DownloadButton = ({
  mediaBlobUrl,
  qid,
  isVideoUploading,
}) => {
  if (!mediaBlobUrl) {
    return null;
  }

  return (
    <React.Fragment>
      {!isVideoUploading ?
        (<a
          id={`vpDownloadVideoButton-${qid}`}
          className={`${styles.vpVideoDownloadButton} ${isVideoUploading ? styles.vpInputDisabled : ''}`}
          href={`${isVideoUploading ? '#' : mediaBlobUrl}`}
          download="recorded-video.mp4"
        ><Icon
            className={styles.vpDownloadIcon}
            icon="download2"
          />
          Download Video
        </a>) : (
          <span className={`${styles.vpVideoDownloadButton} ${styles.vpInputDisabled}`}><Icon
            className={styles.vpDownloadIcon}
            icon="download2"
          />
            Download Video
          </span>
        )
      }
    </React.Fragment>
  );
};

DownloadButton.propTypes = {
  mediaBlobUrl: PropTypes.string,
  qid: PropTypes.string,
  isVideoUploading: PropTypes.bool,
};

function mapStateToProps(state, ownProps) {
  return {
    isVideoUploading: getIsVideoUploadingToBucket(state, ownProps.qid),
  };
}

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(DownloadButton);



// WEBPACK FOOTER //
// ./src/components/CampaignLanding/DownloadButton.jsx